import sanityClient from "@sanity/client";

export default sanityClient({
    projectId: '552cpgqt',
    dataset: 'production',
    apiVersion: '2021-10-21',
    // token: 'sanity-auth-token',
    useCdn: true,
});